import { NgModule } from '@angular/core';
import {
  GutachtenStatiFilterComponentModule,
  GutachtenStatiSorterComponentModule,
  GutachtenStatiListComponentModule
} from '.';

@NgModule({
  imports: [
    GutachtenStatiFilterComponentModule,
    GutachtenStatiSorterComponentModule,
    GutachtenStatiListComponentModule
  ],
  exports: [
    GutachtenStatiFilterComponentModule,
    GutachtenStatiSorterComponentModule,
    GutachtenStatiListComponentModule
  ],
})
export class GutachtenStatiQueryModule { }